
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gray-900 text-white py-6">
        <div className="max-w-7xl mx-auto px-6">
          <a href="/" className="inline-flex items-center text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer mb-4">
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Home
          </a>
          <h1 className="text-4xl font-bold">Privacy Policy</h1>
          <p className="text-gray-300 mt-2">Big Ben Injury Law PLLC</p>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <div className="prose prose-lg max-w-none">
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Disclaimer</h2>
            <p className="text-gray-700 leading-relaxed">
              The information on this website is for general information purposes only. Nothing on this site should be taken as legal advice for any individual case or situation. This information is not intended to create, and receipt or viewing does not constitute, an attorney-client relationship. No content on this site may be reused in any fashion without written permission from www.Bigbeninjurylaw.com
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Privacy Policy</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              We recognize that you may be concerned about our use and disclosure of your personal information. Your privacy is very important to us, and the following will inform you of the information that we, Big Ben Injury Law PLLC., may collect from you, and how it is used. By using our website, www.Bigbeninjurylaw.com, you are accepting the practices described in this policy.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Information Collection</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              We may collect non-personal information, such as a domain name and IP Address. The domain name and IP address reveals nothing personal about you other than the IP address from which you have accessed our site. We may also collect information about the type of Internet browser you are using, operating system, what brought you to our Website, as well as which of our Web pages you have accessed.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Additionally, if you communicate with us regarding our Website or our services, we will collect any information that you provide to us in any such communication.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              We may contact you via email in the future to tell you about specials, new products or services, or changes to this privacy policy.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Information Use</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              We use the collected information primarily for our own internal purposes, such as providing, maintaining, evaluating, and improving our services and Website, fulfilling requests for information, and providing customer support.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Security</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              We follow generally accepted industry standards to protect the information submitted to us, both during transmission and once we receive it.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              If we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for a closed lock icon at the bottom of your web browser, or looking for "https" at the beginning of the address of the web page.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              While we use encryption to protect sensitive information transmitted online, we also protect your information offline. Only employees who need the information to perform a specific job (for example, billing or customer service) are granted access to personally identifiable information. The computers/servers in which we store personally identifiable information are kept in a secure environment.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Cookies</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              We use "cookies" on this site. A cookie is a piece of data stored on a site visitor's hard drive to help us improve your access to our site and identify repeat visitors to our site. For instance, when we use a cookie to identify you, you would not have to log in a password more than once, thereby saving time while on our site. Cookies can also enable us to track and target the interests of our users to enhance the experience on our site. Usage of a cookie is in no way linked to any personally identifiable information on our site.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Sharing</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              We will not sell or otherwise provide the information we collect to outside third parties for the purpose of direct or indirect mass email marketing.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              We will disclose personal information and/or an IP address, when required by law or in the good-faith belief that such action is necessary to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
              <li>Cooperate with the investigations of purported unlawful activities and conform to the edicts of the law or comply with legal process served on our company</li>
              <li>Protect and defend the rights or property of our Website and related properties</li>
              <li>Identify persons who may be violating the law, the rights of third parties, or otherwise misusing our Website or its related properties</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mb-4">
              Please keep in mind that whenever you voluntarily disclose personal information online – for example through e-mail, discussion boards, or elsewhere – that information can be collected and used by others. In short, if you post personal information online that is accessible to the public, you may receive unsolicited messages from other parties in return.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              Ultimately, you are solely responsible for maintaining the secrecy of your personal information. Please be careful and responsible whenever you are online.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Surveys & Contest</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              From time-to-time our site may request information via surveys or contests. Participation in these surveys or contests is completely voluntary and you may choose whether or not to participate and therefore disclose this information. Information requested may include contact information (such as name and shipping address), and demographic information (such as zip code, age).
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              Contact information will be used to notify the winners and award prizes. Survey information will be used for purposes of monitoring or improving the use and satisfaction of this site.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Links</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              This web site contains links to other sites. Please be aware that we are not responsible for the content or privacy practices of such other sites. We encourage our users to be aware when they leave our site and to read the privacy statements of any other site that collects personally identifiable information.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Consent</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              By using this Website, you consent to the collection and use of information as specified above. If we make changes to our Privacy Policy, we will post those changes on this page. Please review this page frequently to remain up-to-date with the information we collect, how we use it, and under what circumstances we disclose it. You must review the new Privacy Policy carefully to make sure you understand our practices and procedures.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you feel that we are not abiding by this privacy policy, you should contact us immediately via telephone at (561) 765-2540 or via mail Attn: Privacy Officer, 1200 N Federal Hwy. Suite 300 Boca Raton FL 33432
            </p>
            <p className="text-gray-700 leading-relaxed mb-6 font-semibold">
              SMS OPT-IN AND PHONE NUMBERS FOR THE PURPOSE OF SMS WILL NOT BE SHARED WITH THIRD PARTIES AND AFFILIATES for marketing purposes.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you have questions or concerns about this Privacy Policy, please contact us:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-800 font-semibold mb-2">Big Ben Injury Law PLLC</p>
              <p className="text-gray-700 mb-1">
                <i className="ri-phone-line mr-2 text-cyan-600"></i>
                Phone: (561) 765-2540
              </p>
              <p className="text-gray-700 mb-1">
                <i className="ri-mail-line mr-2 text-cyan-600"></i>
                Email: Office@Bigbeninjurylaw.com
              </p>
              <p className="text-gray-700">
                <i className="ri-map-pin-line mr-2 text-cyan-600"></i>
                Website: www.Bigbeninjurylaw.com
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
